import { render, staticRenderFns } from "./Survey-detail.vue?vue&type=template&id=91b13140&"
import script from "./Survey-detail.vue?vue&type=script&lang=js&"
export * from "./Survey-detail.vue?vue&type=script&lang=js&"
import style0 from "./Survey-detail.vue?vue&type=style&index=0&lang=scss&spaced=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports